import { http } from './client';
import type {
  PersistedToolRecord,
  ToolCatalogItem,
  ToolRecord,
  ToolTestResponse,
} from './types';

export const toolsApi = {
  async list(): Promise<ToolCatalogItem[]> {
    const res = await http.get<{ items: ToolCatalogItem[] }>('/v1/bot/tools');
    return res.data.items;
  },

  async get(name: string): Promise<PersistedToolRecord | ToolCatalogItem> {
    const res = await http.get<PersistedToolRecord | ToolCatalogItem>(
      `/v1/bot/tools/${encodeURIComponent(name)}`,
    );
    return res.data;
  },

  async create(record: ToolRecord): Promise<{ tool: PersistedToolRecord }> {
    const res = await http.post<{ tool: PersistedToolRecord }>('/v1/bot/tools', record);
    return res.data;
  },

  async update(name: string, record: Partial<ToolRecord>): Promise<{ tool: PersistedToolRecord }> {
    const res = await http.patch<{ tool: PersistedToolRecord }>(
      `/v1/bot/tools/${encodeURIComponent(name)}`,
      record,
    );
    return res.data;
  },

  async setEnabled(
    name: string,
    enabled: boolean,
  ): Promise<{ name: string; source: 'static' | 'dynamic'; enabled: boolean }> {
    const res = await http.patch<{ name: string; source: 'static' | 'dynamic'; enabled: boolean }>(
      `/v1/bot/tools/${encodeURIComponent(name)}/enabled`,
      { enabled },
    );
    return res.data;
  },

  async delete(name: string): Promise<{ deleted: true; name: string }> {
    const res = await http.delete<{ deleted: true; name: string }>(
      `/v1/bot/tools/${encodeURIComponent(name)}`,
    );
    return res.data;
  },

  async test(name: string, inputs: Record<string, unknown>): Promise<ToolTestResponse> {
    const res = await http.post<ToolTestResponse>(
      `/v1/bot/tools/${encodeURIComponent(name)}/test`,
      { inputs },
    );
    return res.data;
  },
};
